export class KullaniciTalep {
    id:number=0;
    kullaniciId:number=0;
    birimId:number=0;
    icerik:string='';
    kategoriId:number=0;
    smsSonucBildir:boolean=false;
    kvkkCheck:boolean=false;
    ePostaSonucBildir:boolean=false;
    kayitTarihi: Date = new Date();
    dosyaUrl:string='';
    guncellemeTarihi: Date = new Date();
    nebisTalepId:number=0;
    //file: File | null = null;
    arsiv:boolean=false;
    //file: : File | null = null;;
}